module.exports = __webpack_public_path__ + "assets/img/35t.e27d7aed.png";